import React, { forwardRef } from 'react'
import { TextProps } from 'rebass'

import { useSTheme } from 'styles/theme'
import { ResponsiveHeaderText } from '../styles'

interface Props extends TextProps {
    text?: string
    textColor?: string
    uncentered?: boolean
    fontFamily?: string
}

const FHeading1 = forwardRef<any, Props>((props: Props, ref) => {
    const theme = useSTheme()
    const fontFamily = theme.fontsV2[window.ORGANIZATION.name]?.header || theme.fontsV2.default

    return (
        <ResponsiveHeaderText
            style={{
                fontFamily: props.fontFamily ? props.fontFamily : fontFamily,
                color: props.textColor ? props.textColor : theme.colors.secondaryColor,
                textAlign: props.uncentered ? 'left' : 'center',
            }}
            dangerouslySetInnerHTML={{ __html: props.text }}
        />
    )
})

FHeading1.displayName = 'FHeading1'

export default FHeading1
